module.exports = __webpack_public_path__ + "909b8474372eb7afe6c6d9c872925e0d.png";